import React from "react";
import "./Explore_Blogs.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { Blog } from "../../../../utils/apis/blog/Blog";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../../../utils/context";
import { IDS } from "../../../../utils/common";

const Explore_Blogs = () => {
  const navigate = useNavigate();
  const { IMG_URL } = useContext(Context);

  const [exploreblog, setExploreBlog] = useState([]);

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const handleServiceClick = (id) => {
    navigate(`/blog/${id}`);
  };

  const getExploreBlog = async () => {
    const res = await Blog();

    if (res?.success) {
      setExploreBlog(res?.data?.data || []);
    }
  };

  useEffect(() => {
    getExploreBlog();
  }, []);

  const topBlog = exploreblog.slice(0, 3);

  return (
    <section className="Explore_Blogs Solar_Insights">
      <div className="container">
        <h5 className="Explore_Blogs_header">Explore Blogs</h5>

        <div className="blog_grid">
          <div className="row">
            {topBlog.map((blog) => (
              <div className="col-lg-12 col-md-6" key={blog.id}>
                <div
                  className="blog_card"
                  style={{
                    backgroundImage: `url(${IDS?.IMG_URL}${blog?.image})`,
                  }}
                  onClick={() => handleServiceClick(blog.id)}
                >
                  <div className="blog_overlay">
                    <div className="blog_meta">
                      <FontAwesomeIcon
                        icon={faUser}
                        style={{ color: "#fff" }}
                      />
                      <span className="author_name">{blog.name}</span>
                      <span className="date">
                        -{" "}
                        {new Date(blog.createdAt).toLocaleDateString("en-GB", {
                          day: "numeric",
                          month: "short",
                          year: "numeric",
                        })}
                      </span>
                    </div>

                    <h3 className="blog_title">{blog.title}</h3>

                    <p className="blog_desc">
                      {htmlToReactParser.parse(blog.description)}
                    </p>

                    <span className="read_more">Read more</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="social_icons_div">
          <p>Follow us on :</p>

          <div className="footer_links">
            {[
              { icon: faFacebookF, link: "https://www.facebook.com" },
              { icon: faInstagram, link: "https://www.instagram.com" },
              {
                icon: faLinkedinIn,
                link: " https://www.linkedin.com/company/hbctc/",
              },
            ].map((item, index) => (
              <a
                key={index}
                href={item.link}
                className="footer_link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="icon_holder">
                  <FontAwesomeIcon icon={item.icon} />
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Explore_Blogs;
